import { ConsoleUser } from "@/types/resources";

export type AccountStatus = "active" | "offboarded";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const UNLIMITED_CREDITS = -1;

export function formatCredits(credits: number, unlimitedLabel: string): string {
  return credits === UNLIMITED_CREDITS
    ? unlimitedLabel
    : credits.toLocaleString();
}

export function formatDomains(domains: string[]): string {
  return domains.map((d) => `@${d}`).join(", ");
}

export function isAllowedEmail(email: string, domains: string[]): boolean {
  const domain = email.trim().toLowerCase().split("@")[1] ?? "";
  return !domains.length || domains.includes(domain);
}

export function isValidEmail(email: string): boolean {
  return EMAIL_PATTERN.test(email.trim());
}

export function slugify(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function userName(
  user: Pick<ConsoleUser, "emailAddress" | "firstName" | "id" | "lastName">
): string {
  const name = `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim();
  return name || user.emailAddress || user.id;
}

export function userStatus(user: ConsoleUser): AccountStatus {
  return user.banned ? "offboarded" : "active";
}
